<template>
  <div id="app">
    <myheader></myheader>
    <router-view></router-view>
    <myfooter></myfooter>
    <mysuspend></mysuspend>
  </div>
</template>

<script>
import myheader from "./components/common/Header";
import myfooter from "./components/common/Footer";
import mysuspend from "./components/common/Suspend";
export default {
  name: 'App',
  components: {
    myheader,
    myfooter,
    mysuspend
  }

}
</script>

<style>
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  /* margin-top: 60px; */
  max-height: 100%;
  overflow: hidden;
}
@media screen and (max-width: 1800px){
  #app{

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: black;
    min-width: 1500px;

  }
}
#upbutton {
  position: fixed;
  right :10%;
  top:55%;
  width:50px;

}
html,body{
  font-family: "STHeiti";
  padding: 0;
  margin: 0;
  /* display: none; */
}
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
min-width: 80px!important;
/* margin-left: 15% !important; */
}
.el-tabs__item.is-active{

color:#2F93b7 !important;
/* font-weight: bold; */
/* font-size: 17px; */
}
.el-tabs__item:hover{

color:#2F93b7 !important;


}
.el-tabs__active-bar{
  background-color: #2F93b7 !important;
}
.el-pagination{
margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue